import React from 'react'
import { Link } from 'react-router-dom'
import { Price } from 'lib/shared/components'
import { ProductAttributeCustomOption } from 'lib/core/data/customer/orders/types'
import { ProductContainer } from 'components/ItemData/components/Styled'
import { Container } from './styled'
import { DEFAULT_CURRENCY_CODE } from 'lib/core/resources/constants'

interface Props {
  item: any
}

export const SubscriptionItem: React.FC<Props> = ({ item }) => {
  const shippingFrequencyInWeeks = item?.frequency_in_cart / 7
  const MEDIA_URL = '/media/catalog/product'
  const CATEGORY_IMAGE_URL = `${process.env.REACT_APP_MAGENTO_URI}${MEDIA_URL}`
  const { price, package_qty: packageQty, qty, thumbnail, name, options, subscription_id: id, sku, packageType } = item ?? {}

  const quantity = Math.round(qty)
  return (
    <Container>
      <div>
        <p>Every {shippingFrequencyInWeeks} weeks</p>
        <ProductContainer>
          <div
            className='product-image'
            style={{
              backgroundImage: `url(${CATEGORY_IMAGE_URL}${thumbnail})`
            }}
          />

          <div className='product-data'>
            <h2>{name}</h2>
            {options?.map((option: ProductAttributeCustomOption, i: number) => {
              return (
                <p key={i}><strong>{option?.label}: {option?.value}</strong></p>
              )
            })}
            <p>
              <strong>
                {quantity} {packageType} of {packageQty} pieces
              </strong>
            </p>
          </div>
        </ProductContainer>

      </div>
      <div className='price-value'>
        <span><Price currency={DEFAULT_CURRENCY_CODE} value={price} /></span>
        <Link to={`/customer/account/subscriptions/detail/${id}/${sku}`}><p>Edit</p></Link>
      </div>
    </Container>
  )
}
